module.exports = __webpack_public_path__ + "img/232.3df9d2e6.jpg";